var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrientationLandscape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.306 19C20.24 19 21 18.216 21 17.25V6.75C21 5.784 20.241 5 19.306 5H4.694C3.76 5 3 5.784 3 6.75v10.5c0 .966.759 1.75 1.694 1.75h14.612zm-.212-1.75H4.906a.216.216 0 01-.212-.219V6.97c0-.12.095-.219.212-.219h14.188c.117 0 .212.098.212.219V17.03c0 .12-.095.219-.212.219z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/e2333f2981a9fd7b87350399b9f504a8-OrientationLandscape.svg";
export { SvgOrientationLandscape as ReactComponent };